import optionValueTypesData from '../data/OptionValueTypes.json';
import optionValuesData from '../data/OptionValues.json';

interface OptionValueTypeRaw {
    Id: number;
    Code: string;
    Description: string;
}

interface OptionValueRaw {
    Id: number;
    OptionValueTypeId: number;
    CompanyId: number;
    Code: string;
    Description: string;
    OrderNumber: number;
}

interface OptionValueDto {
    id: number;
    optionValueTypeId: number;
    companyId: number;
    code: string;
    description: string;
    orderNumber: number;
}

const optionValueTypes = optionValueTypesData as OptionValueTypeRaw[];
const optionValues = optionValuesData as OptionValueRaw[];

const DEFAULT_COMPANY_ID = 154;

/**
 * Service that replaces the previous OptionValueApi HTTP calls.
 * Reads data from local JSON files (OptionValueTypes.json / OptionValues.json)
 * so no network request is performed.
 */
export default class OptionValueApi {
    /**
     * Returns the list of option values for the given type code.
     * Mirrors the previous backend behaviour (filter by CompanyId and OptionValueTypeId,
     * ordered by OrderNumber) and maps the payload to camelCase to keep the
     * existing callers (which use `item.code` / `item.description`) working.
     */
    static async search(type: string, companyId: number = DEFAULT_COMPANY_ID): Promise<any> {
        const typeCode = (type || '').toUpperCase();
        const optionValueType = optionValueTypes.find(
            (item) => item.Code.toUpperCase() === typeCode
        );

        if (!optionValueType) {
            return [];
        }

        const result: OptionValueDto[] = optionValues
            .filter(
                (item) =>
                    item.CompanyId === companyId &&
                    item.OptionValueTypeId === optionValueType.Id
            )
            .sort((a, b) => a.OrderNumber - b.OrderNumber)
            .map((item) => ({
                id: item.Id,
                optionValueTypeId: item.OptionValueTypeId,
                companyId: item.CompanyId,
                code: item.Code,
                description: item.Description,
                orderNumber: item.OrderNumber,
            }));

        return result;
    }
}

